import React, { useState, useEffect } from 'react';
import style from './style.module.css';

import { 
    getLanguageShortname, Language, 
    getLanguageArray, systemLanguage, getLabel,
    settingsLabel,
} from '../../utils/constants';

const Settings: React.FC = () => {

    const [sessionLang, setSessionLang] = useState<Language>(getLanguageArray());

    const [userLanguage, setUserLanguage] = useState<{ short: string | any } | false>(false);
    const user_language = getLanguageShortname();

    useEffect(() => {
        if (user_language) {
            setUserLanguage({ short: user_language.toUpperCase() });
        } else {
            setUserLanguage({ short: ((user_language as unknown) as Language).short || 'EN' });
        }
    }, [user_language]);

    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    useEffect(() => {
        const handler = (e: StorageEvent) => {
            if (e.key === systemLanguage && e.newValue) {
                setSessionLang(JSON.parse(e.newValue));
            }
        };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, []);

    return (
        <div className={style.scoreboard}>
            <div className={style.header}>
                <div className={`${style.greeting} ${style.textContainerGrad}`}>
                    {getLabel(settingsLabel, sessionLang)}
                </div>
                <div className={style.info}>
                    Currently unavailable.
                </div>
            </div>
        </div>
    );
}

export default Settings;
